var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 112,
    height: 50,
    viewBox: "0 0 112 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_27_104)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.039 37.8585C13.7528 37.8585 15.3421 36.4863 15.3421 33.8835C15.3421 31.2807 13.7528 30.0002 11.039 30.0002H6.27656V37.8474L11.039 37.8585ZM11.2143 42.7779H6.27656V49.7224H0V25.0835H11.039C17.5632 25.0835 21.3013 28.1807 21.3013 33.6696C21.3013 37.4363 19.7148 40.1474 16.8228 41.589L22.0055 49.7224H14.8828L11.2143 42.7779Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4959 30.7501H31.5637V49.7223H25.4959V30.7501ZM31.7752 25.2946C31.7752 27.1946 30.4336 28.5335 28.5659 28.5335C26.6983 28.5335 25.3567 27.1946 25.3567 25.2946C25.3567 24.4451 25.6948 23.6305 26.2967 23.0299C26.8985 22.4292 27.7148 22.0918 28.5659 22.0918C29.4171 22.0918 30.2334 22.4292 30.8352 23.0299C31.4371 23.6305 31.7752 24.4451 31.7752 25.2946Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.697 37.7529V49.7223H62.6264V39.4445C62.6264 37.1945 61.3571 35.8195 59.3475 35.8195C57.054 35.8918 55.6428 37.764 55.6428 40.3251V49.7223H49.5444V39.4445C49.5444 37.1945 48.3113 35.8195 46.3017 35.8195C43.9748 35.8918 42.5274 37.764 42.5274 40.3251V49.7223H36.4624V30.7501H42.5302V33.889C43.8356 31.639 46.0206 30.5112 48.8068 30.4751C51.9103 30.4751 54.2038 32.0945 55.1557 34.7695C56.3888 31.9557 58.7185 30.5112 61.8554 30.4751C66.0305 30.4751 68.697 33.3279 68.697 37.7612",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.5844 40.278C77.5844 43.2363 79.3129 45.2057 81.8514 45.2057C84.3898 45.2057 86.0821 43.2363 86.0821 40.278C86.0821 37.3196 84.3564 35.353 81.8514 35.353C79.3463 35.353 77.5844 37.3585 77.5844 40.278ZM92.2195 40.2085C92.2195 46.0419 88.0584 49.9307 81.8514 49.9307C75.6444 49.9307 71.447 46.0585 71.447 40.2085C71.447 34.3585 75.6082 30.5308 81.8514 30.5308C88.0945 30.5308 92.2195 34.3669 92.2195 40.2085Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.516 35.2557C109.112 35.8113 111.639 38.1752 111.639 41.9779C111.639 46.7002 107.937 50.0002 102.19 50.0002C98.8022 50.0002 95.2311 48.8057 92.9849 47.0085L95.5233 42.2585C97.3576 44.2307 99.473 45.2502 101.694 45.2502C104.163 45.2502 105.505 44.0529 105.505 42.0474C105.505 39.9696 104.127 38.9502 101.661 38.9502H97.7222V35.6168L103.222 29.9168H94.229V25.1196H110.523V28.6724L104.349 35.078L105.516 35.2557Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.0166016 24.3028L14.4068 6.62778L20.1239 12.5194L28.7969 0L40.4176 15.4667L45.9538 10.3111L58.3149 24.3028L46.3212 15.4667L40.0502 21.725L29.1643 6.81111L20.3104 19.1472L14.0366 13.625L0.0166016 24.3028Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_27_104"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 111.65,
    height: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWhite);
export default __webpack_public_path__ + "static/media/logo-white.183cec63e8447c97890c03114b650b31.svg";
export { ForwardRef as ReactComponent };